<section class="invitation-section dark" id="requirements">
  <div class="content">
    <p class="title">Te estamos esperando</p>
    <div class="description" #animation>
      <p>
        - Si actualmente eres estudiante universitario, de una carrera a fin a
        la ciencias de la computación, y te encuentras cursando 7º semestre en
        adelante.
      </p>
      <p>
        - Si eres profesional o egresado de carreras afines a ciencias de la
        computación.
      </p>
      <p>- Tienes un nivel avanzado de inglés</p>
      <p>
        - Puedes darle dedicación de tiempo completo a la capacitación (8 - 10
        horas diarias)
      </p>
      <p>¡Anótate!</p>
    </div>
  </div>
</section>
